<template>
  <div class="container mt-3 container_products">
    <div v-if="loading" class="d-flex flex-row justify-content-center loading_card">
      <div class="loading_card_spinner">
        <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3" color="var(--primary-color)" />
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-3">
      <span>({{ total }}) {{ $t('products') }}</span>

      <div>
        <button class="btn btn-sm" :class="show_grid ? 'btn-secondary' : 'btn-outline-secondary'" @click="showGrid">
          <i class="bi bi-grid"></i>
        </button>
        <button class="btn btn-sm" :class="show_list ? 'btn-secondary' : 'btn-outline-secondary'" @click="showList">
          <i class="bi bi-list"></i>
        </button>

        <div class="div_sort">
          <span>{{ $t('Sort by') }} :</span>
          <div class="dropdown-container" style="display: inline">
            <select @change="upadatesort($event)" id="country-select_sort">
              <option value="desc/id">{{ $t("default sorting") }}</option>
              <option value="desc/id">{{ $t("Newest Arrivals") }}</option>
              <option value="asc/id">{{ $t("Oldest Arrivals") }}</option>
              <option value="desc/sale_price">{{ $t("Price - Low to High") }}</option>
              <option value="asc/sale_price">{{ $t("Price - High to Low") }}</option>
              <option value="desc/count_view">{{ $t("Views - Low to High") }}</option>
              <option value="asc/count_view">{{ $t("Views - High to Low") }}</option>
              <option value="desc/quantity">{{ $t("qnt - High to Low") }}</option>
              <option value="asc/quantity">{{ $t("qnt - Low to High") }}</option>
              <option value="desc/count_sold">{{ $t("sold - Low to High") }}</option>
              <option value="asc/count_sold">{{ $t("sold - High to Low") }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <hr style="color: #d1cccc;" />

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">{{ $t('sections') }}</a></li>
        <li class="breadcrumb-item"><a href="#">{{ name }}</a></li>
        <li class="active" aria-current="page">{{ $t('products') }}</li>
      </ol>
    </nav>

    <div class="d-flex flex-nowrap gap-2 overflow-auto category-container">
      <button
        v-for="(item, index) in categories"
        :key="index"
        :id="'li_category' + index"
        class="btn btn-outline-secondary category-item"
        @click="filter_category(item.id, index)"
      >
        <img :src="item.icon" :alt="item.name" class="imge_button" />
        {{ item.name }}
      </button>
    </div>

     <div v-if="products.length==0" class="d-flex flex-row justify-content-center"
      style="min-height:400px">
      <!-- LOADER -->
      <div class="">
        <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3" color="var(--primary-color)" />

      </div>
    </div>

    <div class="mt-4">
      <!-- Grid View -->
      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 g-4" v-if="show_grid">
        <product
          v-for="(item, index) in products"
          :key="index"
          v-bind="item"
          :name="item.name"
                :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer" :unit="item.unit"
                :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount" :qnt="item.qnt"
                :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note" :range_price="item.range_price"  :jellwery="item.jewelry"
        />
      </div>

      <!-- List View -->
      <div class="container mt-4" v-if="show_list">
        <product_list
          v-for="(item, index) in products"
          :key="index"
          v-bind="item"
          :name="item.name"
                :description="item.description" :is_favorit="item.is_favorit" :image="item.image"
                :old_price="item.old_price" :new_price="item.new_price" :productid="item.id" :rate="item.rate"
                :count_view="item.count_views" :is_option="item.is_option" :is_offer="item.is_offer" :unit="item.unit"
                :new="item.is_new" :fetuered="item.is_fetured" :discount="item.discount" :qnt="item.qnt"
                :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note" :range_price="item.range_price"  :jellwery="item.jewelry" 
        />
      </div>
    </div>

    <div class="col-lg-12 text-center">
      <nav aria-label="Page navigation example" class="paginate_div">
        <b-pagination
          v-if="products && products.length !== 0"
          v-model="page"
          :total-rows="count"
          :per-page="paginate"
          :prev-text="$t('prev')"
          :next-text="$t('next')"
          pills
          size="sm"
  class="paginate_theme13"
            @change="handlePageChange"
        />
      </nav>
    </div>
  </div>
</template>

<script>
import product from "../components/one_product_list.vue";
import product_list from "../components/one_product_list _vertical.vue";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  components: { product, product_list, HollowDotsSpinner },
  data() {
    return {
      show_list: false,
      show_grid: true,
      loading: false,
      products: [],
      total: 0,
      page: 1,
      count: 0,
      paginate: 12,
      sort: 'id',
      order: 'desc',
      categories: [],
      category_id: null,
      brands_array: [],
      options_array: [],
      name: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    showGrid() {
      this.show_grid = true;
      this.show_list = false;
    },
    showList() {
      this.show_grid = false;
      this.show_list = true;
    },
    loadData() {
      this.loading = true;
      this.axios.get(`${this.$store.state.base_api_url}${this.$store.storeName}/theme13/section/${this.$route.params.id}`, {
        headers: { "Accept-Language": this.$i18n.locale }
      }).then((res) => {
        const data = res.data.data;
        this.name = data.name;
        this.categories = data.categories;
      }).finally(() => {
        this.loading = false;
      });

      this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/products/filter_product_theme_5`, {
        section_id: this.$route.params.id,
        category: this.category_id,
        options: this.options_array,
        sort: this.sort,
        order: this.order,
        paginate: this.paginate,
        brands: this.brands_array
      }, {
        headers: { "Accept-Language": this.$i18n.locale }
      }).then(res => {
        this.products = res.data.data.products;
        this.count = res.data.meta.total;
        this.total = res.data.meta.total;
      });
    },
     loadDataCategory() {

      this.axios.post(`${this.$store.state.base_api_url}${this.$store.storeName}/products/filter_product_theme_5`, {
        section_id: this.$route.params.id,
        category: this.category_id,
        options: this.options_array,
        sort: this.sort,
        order: this.order,
        paginate: this.paginate,
        brands: this.brands_array
      }, {
        headers: { "Accept-Language": this.$i18n.locale }
      }).then(res => {
        this.products = res.data.data.products;
        this.count = res.data.meta.total;
        this.total = res.data.meta.total;
      });
    },
    upadatesort(event) {
      const [order, sort] = event.target.value.split("/");
      this.order = order;
      this.sort = sort;
      this.loadDataCategory();
    },
    filter_category(id, index) {
      this.category_id = id;
      this.loadDataCategory();
    },
    handlePageChange(val) {
      this.page = val;
      this.loadData();
    }
  },
    watch: {
    langChange() {
        this.loadData();


    },
    "$route.params": {
      handler(newValue) {
        this.loadData();
       

      },
      immediate: true
    }
  },
  updated() {
    this.langChange = this.$i18n.locale

  },
};
</script>

<style scoped>
/* أضف هنا أي تنسيق إضافي إن أردت */
</style>
